enum InPersonInterviewAddressType {
	Undefined = 0,
	JobLocation = 1,
	OtherLocation = 2,
	CompanyAddress = 3,
	JobInterviewAddress = 4,
	OtherAddress = 5
}

export default InPersonInterviewAddressType;
